import { render, staticRenderFns } from "./WebsiteNavigationNestedLink.vue?vue&type=template&id=039db519"
import script from "./WebsiteNavigationNestedLink.vue?vue&type=script&lang=ts"
export * from "./WebsiteNavigationNestedLink.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../nuxt-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports